// True when a character-load error belongs to a character that is NO LONGER the
// active one — i.e. a stale failure from an AvatarModel/OGSModel instance that
// has since been superseded by a character switch.
//
// Why this exists: AvatarModel's loadAll() runs an async GLTF/asset load that
// can't be cleanly cancelled on unmount (the loadingRef guard deliberately
// survives StrictMode's double-invoke, so a per-effect `cancelled` flag would
// break loading). When the user switches away from a broken character, the old
// instance's load still rejects later and calls onError → setError(<old>),
// clobbering the now-loaded new character with the old one's error overlay. The
// bug presents intermittently ("sometimes stuck") because it's a race between
// that rejection and the new character mounting.
//
// The invariant this restores: an error for character X is only honored while X
// is the active character. Errors are tagged with the character id they failed
// on; App.handleError drops any whose id != the live active id.
export function isStaleLoadError(err, activeCharacterId) {
  const failedId = err?.characterId
  return Boolean(failedId && activeCharacterId && failedId !== activeCharacterId)
}
